const { PROD: IMPORT_PROD, DEV: IMPORT_DEV, MODE: IMPORT_MODE, VITE_TAG_VERSION } = import.meta.env;

const PROD = IMPORT_PROD;
const DEV = IMPORT_DEV;
const MODE = IMPORT_MODE;
const TAG_VERSION = VITE_TAG_VERSION;

export { PROD, DEV, MODE, TAG_VERSION };
